module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"type.module":"Тест модуля","type.output":"Выходная диагностика","type.input":"Входная диагностика"}}')
  delete Component.options._Ctor
}
